<template>
  <div>
    <!-- Add here your global components -->
  </div>
</template>

<script>
  export default {
    components: {},
    name: 'main-custom'
  }
</script>



// WEBPACK FOOTER //
// MainCustom.vue?ab0a7c10